import classNames from 'classnames'
import * as React from 'react'
import { DefaultContent } from 'react-content-engine'
import {
  Control,
  Errors,
  FormValidators,
  FormValidatorsFn,
  MapPropsProps,
  Validators,
} from 'react-redux-form'

import FormMessage from 'components/FormMessage'
import { AlignType, FormMessageType } from 'components/FormMessage/FormMessage'
import { UI } from 'Icon/ui'

import Icon from '../Icon'

import './StyledInput.scss'

export interface StyleProps {
  size?: number
  noMarginLeft?: boolean
  noMarginRight?: boolean
  hasFloatingLabel?: boolean
  hasOuterShadow?: boolean
  error?: boolean
}

interface InputProps {
  model?: string | ((state: any) => string)
  name: string
  inputId?: string
  label: string | JSX.Element
  value?: string
  type?: string
  handleChange?: (name: string) => void
  onClick?: () => void

  elementBefore?: JSX.Element
  iconLeading?: JSX.Element
  iconTrailing?: JSX.Element
  iconTrailingClassName?: string
  elementInside?: JSX.Element

  parser?: (val: string) => any
  validators?: Validators | FormValidators | FormValidatorsFn
  validationIcons?: boolean
  validateAlign?: AlignType
  messages?: { [key: string]: string }
  messageProps?: { [key: string]: { [iKey: string]: string } }
  validateOn?: string
  hideValidation?: boolean

  componentProps?: any
  styleProps?: StyleProps
  outerClassName?: string
  children?: React.ReactNode | undefined
}

interface InputState {
  isValid?: boolean
  isFocus?: boolean
  viewError: boolean
}

class Input extends React.Component<InputProps, InputState> {
  public static defaultProps = { type: 'text' }

  constructor(props: InputProps) {
    super(props)
    this.state = {
      viewError: false,
    }
  }

  public renderTrailing = () => {
    if (this.props.validationIcons && this.state.isValid) {
      return (
        <div className="icon-trailing icon-valid">
          <Icon icon={UI.checkmark} />
        </div>
      )
    } else if (this.props.validationIcons && this.state.isValid === false) {
      return (
        <div className="icon-trailing icon-error">
          <Icon icon={UI.warningMark} />
        </div>
      )
    } else if (this.props.iconTrailing) {
      return (
        <div className={`icon-trailing ${this.props.iconTrailingClassName}`}>
          <Icon icon={this.props.iconTrailing} />
        </div>
      )
    }
    return null
  }

  public render() {
    const {
      styleProps,
      componentProps,
      model,
      label,
      validators,
      messages,
      hideValidation,
      outerClassName,
    } = this.props
    const className = classNames(
      styleProps
        ? styleProps.hasFloatingLabel
          ? 'has-floating-label'
          : ''
        : '',
      styleProps ? (styleProps.hasOuterShadow ? 'has-outer-shadow' : '') : '',
      styleProps ? (styleProps.error ? 'form-error' : '') : '',
    )

    const inputProps = this.getInputProps(componentProps)
    const controlProps = this.getControlProps(className, inputProps)

    const wrapperClassName = classNames(
      'form-element-wrapper',
      outerClassName ? outerClassName : false,
      styleProps ? (styleProps.size ? `is-size-${styleProps.size}` : '') : '',
      styleProps ? (styleProps.noMarginLeft ? 'no-margin-left' : '') : '',
      styleProps ? (styleProps.noMarginRight ? 'no-margin-right' : '') : '',
    )

    return (
      <div className={wrapperClassName} onClick={this.props.onClick}>
        {model !== undefined && validators !== undefined ? (
          <Errors
            model={model}
            show="touched"
            messages={messages}
            component={props => {
              const messageProps = this.props.messageProps || {}
              let key = null
              console.log({ messages, messageProps })
              if (messages !== undefined) {
                Object.keys(messages).forEach(x => {
                  if (props.children === messages[x]) {
                    key = x
                  }
                })
              }

              let vars = {}
              if (key !== null) {
                vars = messageProps[key]
              }
              return (
                <>
                  <DefaultContent
                    vars={vars}
                    contentKey={`validation-valid-${props.children}`}
                  >
                    {`validation-valid-${props.children}`}
                  </DefaultContent>
                  <br />
                </>
              )
            }}
            wrapper={props => {
              return hideValidation !== true &&
                props.children &&
                ((props.children as any[]) || []).length > 0 ? (
                <FormMessage
                  type={FormMessageType.Error}
                  show={this.state.viewError}
                  align={this.props.validateAlign}
                  onClose={() => this.setState({ viewError: false })}
                >
                  {props.children}
                </FormMessage>
              ) : null
            }}
          />
        ) : null}

        <label htmlFor={inputProps.id}>{label}</label>
        {this.state.isFocus === true || this.state.isFocus === undefined
          ? this.props.children
          : null}
        {this.props.elementBefore ? (
          <div className="icon-before">{this.props.elementBefore}</div>
        ) : null}

        {model !== undefined ? (
          <Control model={model} {...controlProps} />
        ) : (
          <input className={className} {...inputProps} />
        )}

        {this.props.iconLeading ? (
          <div className="icon-leading">
            <Icon icon={this.props.iconLeading} />
          </div>
        ) : null}

        {this.renderTrailing()}

        {this.props.elementInside ? (
          <div className="icon-inside">{this.props.elementInside}</div>
        ) : null}
      </div>
    )
  }

  private getControlProps = (className: string, inputProps: any) => {
    const { parser, validateOn, validators } = this.props
    const controlProps: any = {
      parser,
      validateOn: validateOn ? validateOn : 'change',
      mapProps: {
        className: (formState: MapPropsProps) => {
          return classNames(
            className,
            !formState.fieldValue.valid && formState.fieldValue.touched
              ? 'form-error'
              : '',
            this.props.validationIcons && formState.fieldValue.valid
              ? 'form-correct'
              : '',
          )
        },
        onLoad: (formState: MapPropsProps) => {
          // Because of the order of the actions we can't update onChange or onBlur
          // so settled on onLoad (even though it's anti-pattern)
          // Can't use componentWillMount since can't get formState then
          const isValid = formState.fieldValue.valid as boolean
          const isFocus = formState.fieldValue.focus as boolean
          if (this.state.isValid !== isValid) {
            setTimeout(() => {
              this.setState({ isValid })
            }, 0)
          }
          if (this.state.isFocus !== isFocus) {
            setTimeout(() => {
              this.setState({ isFocus })
            }, 0)
          }
        },
      },
      ...inputProps,
    }
    if (validators !== undefined) {
      controlProps.validators = validators
    }

    return controlProps
  }

  private getInputProps = (componentProps?: any) => {
    const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
      if (this.props.handleChange) {
        this.props.handleChange(e.currentTarget.value)
      }
    }
    const handleFocus = (e: React.FormEvent<HTMLInputElement>) => {
      this.setState({ viewError: true })
    }
    const handleLoad = (e: React.SyntheticEvent<HTMLInputElement>) => {
      if (e !== undefined && this.props.handleChange) {
        this.props.handleChange(e.toString())
      }
    }

    const { model, value, type, inputId, name } = this.props
    let inputProps = {
      type,
      id: inputId ? inputId : `${name}-${btoa(name)}`,
      name,
      placeholder: ' ',
      onChange: handleChange,
      onFocus: handleFocus,
      onLoad: handleLoad,
    }
    if (componentProps) {
      inputProps = { ...inputProps, ...componentProps }
    }
    inputProps = !model
      ? Object.assign({}, inputProps, {
          value,
        })
      : inputProps

    return inputProps
  }
}

export default Input
